import { jsx as i, jsxs as Q, Fragment as Te } from "react/jsx-runtime";
import * as o from "react";
import * as _e from "react-dom";
import { c as P } from "./index-DLeNytVF.js";
import { c as gt } from "./index-CUE0gmT0.js";
import { u as B } from "./index-DLcqcWxM.js";
import { c as St } from "./index-UFb2E87s.js";
import { u as wt } from "./index-ByaXH_ih.js";
import { D as yt } from "./index-Dz0AUfZX.js";
import { h as xt, u as Ct, R as It, F as Tt } from "./index-BUY6qYfp.js";
import { u as Ne } from "./index-umR1UobZ.js";
import { c as Ee, A as Nt, C as bt, R as Pt, a as Rt } from "./index-Duz4GUys.js";
import { P as _t } from "./index-CsGiVPqA.js";
import { P as M, c as Et } from "./index-BrTLHETv.js";
import { u as Mt } from "./index-DwYXX2sM.js";
import { u as Pe } from "./index-DYfkNB0n.js";
import { u as G } from "./index-DuekHEmj.js";
import { u as At } from "./index-BZPx6jYI.js";
import { a as Ot } from "./index-DcK06DuQ.js";
import { $ as j } from "./utils-CTvPli9r.js";
import { c as Me } from "./createLucideIcon-Bs_bgX_W.js";
import { C as Dt } from "./check-VaVUBvxu.js";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lt = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Ae = Me("chevron-down", Lt);
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kt = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], Bt = Me("chevron-up", kt);
function Re(t, [n, e]) {
  return Math.min(e, Math.max(n, t));
}
var Vt = [" ", "Enter", "ArrowUp", "ArrowDown"], Ht = [" ", "Enter"], ee = "Select", [de, pe, Ut] = gt(ee), [ne, Vo] = St(ee, [
  Ut,
  Ee
]), ue = Ee(), [Ft, Y] = ne(ee), [Wt, Kt] = ne(ee), Oe = (t) => {
  const {
    __scopeSelect: n,
    children: e,
    open: s,
    defaultOpen: c,
    onOpenChange: u,
    value: a,
    defaultValue: l,
    onValueChange: r,
    dir: f,
    name: g,
    autoComplete: y,
    disabled: N,
    required: b,
    form: T
  } = t, d = ue(n), [v, x] = o.useState(null), [p, h] = o.useState(null), [A, O] = o.useState(!1), re = wt(f), [R, L] = Pe({
    prop: s,
    defaultProp: c ?? !1,
    onChange: u,
    caller: ee
  }), [K, X] = Pe({
    prop: a,
    defaultProp: l,
    onChange: r,
    caller: ee
  }), V = o.useRef(null), H = v ? T || !!v.closest("form") : !0, [z, U] = o.useState(/* @__PURE__ */ new Set()), F = Array.from(z).map((_) => _.props.value).join(";");
  return /* @__PURE__ */ i(Pt, { ...d, children: /* @__PURE__ */ Q(
    Ft,
    {
      required: b,
      scope: n,
      trigger: v,
      onTriggerChange: x,
      valueNode: p,
      onValueNodeChange: h,
      valueNodeHasChildren: A,
      onValueNodeHasChildrenChange: O,
      contentId: Ne(),
      value: K,
      onValueChange: X,
      open: R,
      onOpenChange: L,
      dir: re,
      triggerPointerDownPosRef: V,
      disabled: N,
      children: [
        /* @__PURE__ */ i(de.Provider, { scope: n, children: /* @__PURE__ */ i(
          Wt,
          {
            scope: t.__scopeSelect,
            onNativeOptionAdd: o.useCallback((_) => {
              U((k) => new Set(k).add(_));
            }, []),
            onNativeOptionRemove: o.useCallback((_) => {
              U((k) => {
                const W = new Set(k);
                return W.delete(_), W;
              });
            }, []),
            children: e
          }
        ) }),
        H ? /* @__PURE__ */ Q(
          rt,
          {
            "aria-hidden": !0,
            required: b,
            tabIndex: -1,
            name: g,
            autoComplete: y,
            value: K,
            onChange: (_) => X(_.target.value),
            disabled: N,
            form: T,
            children: [
              K === void 0 ? /* @__PURE__ */ i("option", { value: "" }) : null,
              Array.from(z)
            ]
          },
          F
        ) : null
      ]
    }
  ) });
};
Oe.displayName = ee;
var De = "SelectTrigger", Le = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, disabled: s = !1, ...c } = t, u = ue(e), a = Y(De, e), l = a.disabled || s, r = B(n, a.onTriggerChange), f = pe(e), g = o.useRef("touch"), [y, N, b] = at((d) => {
      const v = f().filter((h) => !h.disabled), x = v.find((h) => h.value === a.value), p = lt(v, d, x);
      p !== void 0 && a.onValueChange(p.value);
    }), T = (d) => {
      l || (a.onOpenChange(!0), b()), d && (a.triggerPointerDownPosRef.current = {
        x: Math.round(d.pageX),
        y: Math.round(d.pageY)
      });
    };
    return /* @__PURE__ */ i(Nt, { asChild: !0, ...u, children: /* @__PURE__ */ i(
      M.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: l,
        "data-disabled": l ? "" : void 0,
        "data-placeholder": st(a.value) ? "" : void 0,
        ...c,
        ref: r,
        onClick: P(c.onClick, (d) => {
          d.currentTarget.focus(), g.current !== "mouse" && T(d);
        }),
        onPointerDown: P(c.onPointerDown, (d) => {
          g.current = d.pointerType;
          const v = d.target;
          v.hasPointerCapture(d.pointerId) && v.releasePointerCapture(d.pointerId), d.button === 0 && d.ctrlKey === !1 && d.pointerType === "mouse" && (T(d), d.preventDefault());
        }),
        onKeyDown: P(c.onKeyDown, (d) => {
          const v = y.current !== "";
          !(d.ctrlKey || d.altKey || d.metaKey) && d.key.length === 1 && N(d.key), !(v && d.key === " ") && Vt.includes(d.key) && (T(), d.preventDefault());
        })
      }
    ) });
  }
);
Le.displayName = De;
var ke = "SelectValue", Be = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, className: s, style: c, children: u, placeholder: a = "", ...l } = t, r = Y(ke, e), { onValueNodeHasChildrenChange: f } = r, g = u !== void 0, y = B(n, r.onValueNodeChange);
    return G(() => {
      f(g);
    }, [f, g]), /* @__PURE__ */ i(
      M.span,
      {
        ...l,
        ref: y,
        style: { pointerEvents: "none" },
        children: st(r.value) ? /* @__PURE__ */ i(Te, { children: a }) : u
      }
    );
  }
);
Be.displayName = ke;
var zt = "SelectIcon", Ve = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, children: s, ...c } = t;
    return /* @__PURE__ */ i(M.span, { "aria-hidden": !0, ...c, ref: n, children: s || "▼" });
  }
);
Ve.displayName = zt;
var $t = "SelectPortal", He = (t) => /* @__PURE__ */ i(_t, { asChild: !0, ...t });
He.displayName = $t;
var te = "SelectContent", Ue = o.forwardRef(
  (t, n) => {
    const e = Y(te, t.__scopeSelect), [s, c] = o.useState();
    if (G(() => {
      c(new DocumentFragment());
    }, []), !e.open) {
      const u = s;
      return u ? _e.createPortal(
        /* @__PURE__ */ i(Fe, { scope: t.__scopeSelect, children: /* @__PURE__ */ i(de.Slot, { scope: t.__scopeSelect, children: /* @__PURE__ */ i("div", { children: t.children }) }) }),
        u
      ) : null;
    }
    return /* @__PURE__ */ i(We, { ...t, ref: n });
  }
);
Ue.displayName = te;
var D = 10, [Fe, q] = ne(te), Gt = "SelectContentImpl", jt = Et("SelectContent.RemoveScroll"), We = o.forwardRef(
  (t, n) => {
    const {
      __scopeSelect: e,
      position: s = "item-aligned",
      onCloseAutoFocus: c,
      onEscapeKeyDown: u,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: l,
      sideOffset: r,
      align: f,
      alignOffset: g,
      arrowPadding: y,
      collisionBoundary: N,
      collisionPadding: b,
      sticky: T,
      hideWhenDetached: d,
      avoidCollisions: v,
      //
      ...x
    } = t, p = Y(te, e), [h, A] = o.useState(null), [O, re] = o.useState(null), R = B(n, (m) => A(m)), [L, K] = o.useState(null), [X, V] = o.useState(
      null
    ), H = pe(e), [z, U] = o.useState(!1), F = o.useRef(!1);
    o.useEffect(() => {
      if (h) return xt(h);
    }, [h]), Ct();
    const _ = o.useCallback(
      (m) => {
        const [I, ...E] = H().map((w) => w.ref.current), [C] = E.slice(-1), S = document.activeElement;
        for (const w of m)
          if (w === S || (w == null || w.scrollIntoView({ block: "nearest" }), w === I && O && (O.scrollTop = 0), w === C && O && (O.scrollTop = O.scrollHeight), w == null || w.focus(), document.activeElement !== S)) return;
      },
      [H, O]
    ), k = o.useCallback(
      () => _([L, h]),
      [_, L, h]
    );
    o.useEffect(() => {
      z && k();
    }, [z, k]);
    const { onOpenChange: W, triggerPointerDownPosRef: $ } = p;
    o.useEffect(() => {
      if (h) {
        let m = { x: 0, y: 0 };
        const I = (C) => {
          var S, w;
          m = {
            x: Math.abs(Math.round(C.pageX) - (((S = $.current) == null ? void 0 : S.x) ?? 0)),
            y: Math.abs(Math.round(C.pageY) - (((w = $.current) == null ? void 0 : w.y) ?? 0))
          };
        }, E = (C) => {
          m.x <= 10 && m.y <= 10 ? C.preventDefault() : h.contains(C.target) || W(!1), document.removeEventListener("pointermove", I), $.current = null;
        };
        return $.current !== null && (document.addEventListener("pointermove", I), document.addEventListener("pointerup", E, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", I), document.removeEventListener("pointerup", E, { capture: !0 });
        };
      }
    }, [h, W, $]), o.useEffect(() => {
      const m = () => W(!1);
      return window.addEventListener("blur", m), window.addEventListener("resize", m), () => {
        window.removeEventListener("blur", m), window.removeEventListener("resize", m);
      };
    }, [W]);
    const [fe, le] = at((m) => {
      const I = H().filter((S) => !S.disabled), E = I.find((S) => S.ref.current === document.activeElement), C = lt(I, m, E);
      C && setTimeout(() => C.ref.current.focus());
    }), me = o.useCallback(
      (m, I, E) => {
        const C = !F.current && !E;
        (p.value !== void 0 && p.value === I || C) && (K(m), C && (F.current = !0));
      },
      [p.value]
    ), he = o.useCallback(() => h == null ? void 0 : h.focus(), [h]), oe = o.useCallback(
      (m, I, E) => {
        const C = !F.current && !E;
        (p.value !== void 0 && p.value === I || C) && V(m);
      },
      [p.value]
    ), ce = s === "popper" ? we : Ke, se = ce === we ? {
      side: l,
      sideOffset: r,
      align: f,
      alignOffset: g,
      arrowPadding: y,
      collisionBoundary: N,
      collisionPadding: b,
      sticky: T,
      hideWhenDetached: d,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ i(
      Fe,
      {
        scope: e,
        content: h,
        viewport: O,
        onViewportChange: re,
        itemRefCallback: me,
        selectedItem: L,
        onItemLeave: he,
        itemTextRefCallback: oe,
        focusSelectedItem: k,
        selectedItemText: X,
        position: s,
        isPositioned: z,
        searchRef: fe,
        children: /* @__PURE__ */ i(It, { as: jt, allowPinchZoom: !0, children: /* @__PURE__ */ i(
          Tt,
          {
            asChild: !0,
            trapped: p.open,
            onMountAutoFocus: (m) => {
              m.preventDefault();
            },
            onUnmountAutoFocus: P(c, (m) => {
              var I;
              (I = p.trigger) == null || I.focus({ preventScroll: !0 }), m.preventDefault();
            }),
            children: /* @__PURE__ */ i(
              yt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: u,
                onPointerDownOutside: a,
                onFocusOutside: (m) => m.preventDefault(),
                onDismiss: () => p.onOpenChange(!1),
                children: /* @__PURE__ */ i(
                  ce,
                  {
                    role: "listbox",
                    id: p.contentId,
                    "data-state": p.open ? "open" : "closed",
                    dir: p.dir,
                    onContextMenu: (m) => m.preventDefault(),
                    ...x,
                    ...se,
                    onPlaced: () => U(!0),
                    ref: R,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...x.style
                    },
                    onKeyDown: P(x.onKeyDown, (m) => {
                      const I = m.ctrlKey || m.altKey || m.metaKey;
                      if (m.key === "Tab" && m.preventDefault(), !I && m.key.length === 1 && le(m.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(m.key)) {
                        let C = H().filter((S) => !S.disabled).map((S) => S.ref.current);
                        if (["ArrowUp", "End"].includes(m.key) && (C = C.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(m.key)) {
                          const S = m.target, w = C.indexOf(S);
                          C = C.slice(w + 1);
                        }
                        setTimeout(() => _(C)), m.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
We.displayName = Gt;
var Yt = "SelectItemAlignedPosition", Ke = o.forwardRef((t, n) => {
  const { __scopeSelect: e, onPlaced: s, ...c } = t, u = Y(te, e), a = q(te, e), [l, r] = o.useState(null), [f, g] = o.useState(null), y = B(n, (R) => g(R)), N = pe(e), b = o.useRef(!1), T = o.useRef(!0), { viewport: d, selectedItem: v, selectedItemText: x, focusSelectedItem: p } = a, h = o.useCallback(() => {
    if (u.trigger && u.valueNode && l && f && d && v && x) {
      const R = u.trigger.getBoundingClientRect(), L = f.getBoundingClientRect(), K = u.valueNode.getBoundingClientRect(), X = x.getBoundingClientRect();
      if (u.dir !== "rtl") {
        const S = X.left - L.left, w = K.left - S, Z = R.left - w, J = R.width + Z, ve = Math.max(J, L.width), ge = window.innerWidth - D, Se = Re(w, [
          D,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(D, ge - ve)
        ]);
        l.style.minWidth = J + "px", l.style.left = Se + "px";
      } else {
        const S = L.right - X.right, w = window.innerWidth - K.right - S, Z = window.innerWidth - R.right - w, J = R.width + Z, ve = Math.max(J, L.width), ge = window.innerWidth - D, Se = Re(w, [
          D,
          Math.max(D, ge - ve)
        ]);
        l.style.minWidth = J + "px", l.style.right = Se + "px";
      }
      const V = N(), H = window.innerHeight - D * 2, z = d.scrollHeight, U = window.getComputedStyle(f), F = parseInt(U.borderTopWidth, 10), _ = parseInt(U.paddingTop, 10), k = parseInt(U.borderBottomWidth, 10), W = parseInt(U.paddingBottom, 10), $ = F + _ + z + W + k, fe = Math.min(v.offsetHeight * 5, $), le = window.getComputedStyle(d), me = parseInt(le.paddingTop, 10), he = parseInt(le.paddingBottom, 10), oe = R.top + R.height / 2 - D, ce = H - oe, se = v.offsetHeight / 2, m = v.offsetTop + se, I = F + _ + m, E = $ - I;
      if (I <= oe) {
        const S = V.length > 0 && v === V[V.length - 1].ref.current;
        l.style.bottom = "0px";
        const w = f.clientHeight - d.offsetTop - d.offsetHeight, Z = Math.max(
          ce,
          se + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (S ? he : 0) + w + k
        ), J = I + Z;
        l.style.height = J + "px";
      } else {
        const S = V.length > 0 && v === V[0].ref.current;
        l.style.top = "0px";
        const Z = Math.max(
          oe,
          F + d.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (S ? me : 0) + se
        ) + E;
        l.style.height = Z + "px", d.scrollTop = I - oe + d.offsetTop;
      }
      l.style.margin = `${D}px 0`, l.style.minHeight = fe + "px", l.style.maxHeight = H + "px", s == null || s(), requestAnimationFrame(() => b.current = !0);
    }
  }, [
    N,
    u.trigger,
    u.valueNode,
    l,
    f,
    d,
    v,
    x,
    u.dir,
    s
  ]);
  G(() => h(), [h]);
  const [A, O] = o.useState();
  G(() => {
    f && O(window.getComputedStyle(f).zIndex);
  }, [f]);
  const re = o.useCallback(
    (R) => {
      R && T.current === !0 && (h(), p == null || p(), T.current = !1);
    },
    [h, p]
  );
  return /* @__PURE__ */ i(
    Xt,
    {
      scope: e,
      contentWrapper: l,
      shouldExpandOnScrollRef: b,
      onScrollButtonChange: re,
      children: /* @__PURE__ */ i(
        "div",
        {
          ref: r,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: A
          },
          children: /* @__PURE__ */ i(
            M.div,
            {
              ...c,
              ref: y,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...c.style
              }
            }
          )
        }
      )
    }
  );
});
Ke.displayName = Yt;
var qt = "SelectPopperPosition", we = o.forwardRef((t, n) => {
  const {
    __scopeSelect: e,
    align: s = "start",
    collisionPadding: c = D,
    ...u
  } = t, a = ue(e);
  return /* @__PURE__ */ i(
    bt,
    {
      ...a,
      ...u,
      ref: n,
      align: s,
      collisionPadding: c,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...u.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
we.displayName = qt;
var [Xt, be] = ne(te, {}), ye = "SelectViewport", ze = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, nonce: s, ...c } = t, u = q(ye, e), a = be(ye, e), l = B(n, u.onViewportChange), r = o.useRef(0);
    return /* @__PURE__ */ Q(Te, { children: [
      /* @__PURE__ */ i(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: s
        }
      ),
      /* @__PURE__ */ i(de.Slot, { scope: e, children: /* @__PURE__ */ i(
        M.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...c,
          ref: l,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...c.style
          },
          onScroll: P(c.onScroll, (f) => {
            const g = f.currentTarget, { contentWrapper: y, shouldExpandOnScrollRef: N } = a;
            if (N != null && N.current && y) {
              const b = Math.abs(r.current - g.scrollTop);
              if (b > 0) {
                const T = window.innerHeight - D * 2, d = parseFloat(y.style.minHeight), v = parseFloat(y.style.height), x = Math.max(d, v);
                if (x < T) {
                  const p = x + b, h = Math.min(T, p), A = p - h;
                  y.style.height = h + "px", y.style.bottom === "0px" && (g.scrollTop = A > 0 ? A : 0, y.style.justifyContent = "flex-end");
                }
              }
            }
            r.current = g.scrollTop;
          })
        }
      ) })
    ] });
  }
);
ze.displayName = ye;
var $e = "SelectGroup", [Zt, Jt] = ne($e), Ge = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...s } = t, c = Ne();
    return /* @__PURE__ */ i(Zt, { scope: e, id: c, children: /* @__PURE__ */ i(M.div, { role: "group", "aria-labelledby": c, ...s, ref: n }) });
  }
);
Ge.displayName = $e;
var je = "SelectLabel", Ye = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...s } = t, c = Jt(je, e);
    return /* @__PURE__ */ i(M.div, { id: c.id, ...s, ref: n });
  }
);
Ye.displayName = je;
var ie = "SelectItem", [Qt, qe] = ne(ie), Xe = o.forwardRef(
  (t, n) => {
    const {
      __scopeSelect: e,
      value: s,
      disabled: c = !1,
      textValue: u,
      ...a
    } = t, l = Y(ie, e), r = q(ie, e), f = l.value === s, [g, y] = o.useState(u ?? ""), [N, b] = o.useState(!1), T = B(
      n,
      (p) => {
        var h;
        return (h = r.itemRefCallback) == null ? void 0 : h.call(r, p, s, c);
      }
    ), d = Ne(), v = o.useRef("touch"), x = () => {
      c || (l.onValueChange(s), l.onOpenChange(!1));
    };
    if (s === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ i(
      Qt,
      {
        scope: e,
        value: s,
        disabled: c,
        textId: d,
        isSelected: f,
        onItemTextChange: o.useCallback((p) => {
          y((h) => h || ((p == null ? void 0 : p.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ i(
          de.ItemSlot,
          {
            scope: e,
            value: s,
            disabled: c,
            textValue: g,
            children: /* @__PURE__ */ i(
              M.div,
              {
                role: "option",
                "aria-labelledby": d,
                "data-highlighted": N ? "" : void 0,
                "aria-selected": f && N,
                "data-state": f ? "checked" : "unchecked",
                "aria-disabled": c || void 0,
                "data-disabled": c ? "" : void 0,
                tabIndex: c ? void 0 : -1,
                ...a,
                ref: T,
                onFocus: P(a.onFocus, () => b(!0)),
                onBlur: P(a.onBlur, () => b(!1)),
                onClick: P(a.onClick, () => {
                  v.current !== "mouse" && x();
                }),
                onPointerUp: P(a.onPointerUp, () => {
                  v.current === "mouse" && x();
                }),
                onPointerDown: P(a.onPointerDown, (p) => {
                  v.current = p.pointerType;
                }),
                onPointerMove: P(a.onPointerMove, (p) => {
                  var h;
                  v.current = p.pointerType, c ? (h = r.onItemLeave) == null || h.call(r) : v.current === "mouse" && p.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: P(a.onPointerLeave, (p) => {
                  var h;
                  p.currentTarget === document.activeElement && ((h = r.onItemLeave) == null || h.call(r));
                }),
                onKeyDown: P(a.onKeyDown, (p) => {
                  var A;
                  ((A = r.searchRef) == null ? void 0 : A.current) !== "" && p.key === " " || (Ht.includes(p.key) && x(), p.key === " " && p.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Xe.displayName = ie;
var ae = "SelectItemText", Ze = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, className: s, style: c, ...u } = t, a = Y(ae, e), l = q(ae, e), r = qe(ae, e), f = Kt(ae, e), [g, y] = o.useState(null), N = B(
      n,
      (x) => y(x),
      r.onItemTextChange,
      (x) => {
        var p;
        return (p = l.itemTextRefCallback) == null ? void 0 : p.call(l, x, r.value, r.disabled);
      }
    ), b = g == null ? void 0 : g.textContent, T = o.useMemo(
      () => /* @__PURE__ */ i("option", { value: r.value, disabled: r.disabled, children: b }, r.value),
      [r.disabled, r.value, b]
    ), { onNativeOptionAdd: d, onNativeOptionRemove: v } = f;
    return G(() => (d(T), () => v(T)), [d, v, T]), /* @__PURE__ */ Q(Te, { children: [
      /* @__PURE__ */ i(M.span, { id: r.textId, ...u, ref: N }),
      r.isSelected && a.valueNode && !a.valueNodeHasChildren ? _e.createPortal(u.children, a.valueNode) : null
    ] });
  }
);
Ze.displayName = ae;
var Je = "SelectItemIndicator", Qe = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...s } = t;
    return qe(Je, e).isSelected ? /* @__PURE__ */ i(M.span, { "aria-hidden": !0, ...s, ref: n }) : null;
  }
);
Qe.displayName = Je;
var xe = "SelectScrollUpButton", et = o.forwardRef((t, n) => {
  const e = q(xe, t.__scopeSelect), s = be(xe, t.__scopeSelect), [c, u] = o.useState(!1), a = B(n, s.onScrollButtonChange);
  return G(() => {
    if (e.viewport && e.isPositioned) {
      let l = function() {
        const f = r.scrollTop > 0;
        u(f);
      };
      const r = e.viewport;
      return l(), r.addEventListener("scroll", l), () => r.removeEventListener("scroll", l);
    }
  }, [e.viewport, e.isPositioned]), c ? /* @__PURE__ */ i(
    ot,
    {
      ...t,
      ref: a,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: r } = e;
        l && r && (l.scrollTop = l.scrollTop - r.offsetHeight);
      }
    }
  ) : null;
});
et.displayName = xe;
var Ce = "SelectScrollDownButton", tt = o.forwardRef((t, n) => {
  const e = q(Ce, t.__scopeSelect), s = be(Ce, t.__scopeSelect), [c, u] = o.useState(!1), a = B(n, s.onScrollButtonChange);
  return G(() => {
    if (e.viewport && e.isPositioned) {
      let l = function() {
        const f = r.scrollHeight - r.clientHeight, g = Math.ceil(r.scrollTop) < f;
        u(g);
      };
      const r = e.viewport;
      return l(), r.addEventListener("scroll", l), () => r.removeEventListener("scroll", l);
    }
  }, [e.viewport, e.isPositioned]), c ? /* @__PURE__ */ i(
    ot,
    {
      ...t,
      ref: a,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: r } = e;
        l && r && (l.scrollTop = l.scrollTop + r.offsetHeight);
      }
    }
  ) : null;
});
tt.displayName = Ce;
var ot = o.forwardRef((t, n) => {
  const { __scopeSelect: e, onAutoScroll: s, ...c } = t, u = q("SelectScrollButton", e), a = o.useRef(null), l = pe(e), r = o.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return o.useEffect(() => () => r(), [r]), G(() => {
    var g;
    const f = l().find((y) => y.ref.current === document.activeElement);
    (g = f == null ? void 0 : f.ref.current) == null || g.scrollIntoView({ block: "nearest" });
  }, [l]), /* @__PURE__ */ i(
    M.div,
    {
      "aria-hidden": !0,
      ...c,
      ref: n,
      style: { flexShrink: 0, ...c.style },
      onPointerDown: P(c.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(s, 50));
      }),
      onPointerMove: P(c.onPointerMove, () => {
        var f;
        (f = u.onItemLeave) == null || f.call(u), a.current === null && (a.current = window.setInterval(s, 50));
      }),
      onPointerLeave: P(c.onPointerLeave, () => {
        r();
      })
    }
  );
}), eo = "SelectSeparator", nt = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...s } = t;
    return /* @__PURE__ */ i(M.div, { "aria-hidden": !0, ...s, ref: n });
  }
);
nt.displayName = eo;
var Ie = "SelectArrow", to = o.forwardRef(
  (t, n) => {
    const { __scopeSelect: e, ...s } = t, c = ue(e), u = Y(Ie, e), a = q(Ie, e);
    return u.open && a.position === "popper" ? /* @__PURE__ */ i(Rt, { ...c, ...s, ref: n }) : null;
  }
);
to.displayName = Ie;
var oo = "SelectBubbleInput", rt = o.forwardRef(
  ({ __scopeSelect: t, value: n, ...e }, s) => {
    const c = o.useRef(null), u = B(s, c), a = At(n);
    return o.useEffect(() => {
      const l = c.current;
      if (!l) return;
      const r = window.HTMLSelectElement.prototype, g = Object.getOwnPropertyDescriptor(
        r,
        "value"
      ).set;
      if (a !== n && g) {
        const y = new Event("change", { bubbles: !0 });
        g.call(l, n), l.dispatchEvent(y);
      }
    }, [a, n]), /* @__PURE__ */ i(
      M.select,
      {
        ...e,
        style: { ...Ot, ...e.style },
        ref: u,
        defaultValue: n
      }
    );
  }
);
rt.displayName = oo;
function st(t) {
  return t === "" || t === void 0;
}
function at(t) {
  const n = Mt(t), e = o.useRef(""), s = o.useRef(0), c = o.useCallback(
    (a) => {
      const l = e.current + a;
      n(l), function r(f) {
        e.current = f, window.clearTimeout(s.current), f !== "" && (s.current = window.setTimeout(() => r(""), 1e3));
      }(l);
    },
    [n]
  ), u = o.useCallback(() => {
    e.current = "", window.clearTimeout(s.current);
  }, []);
  return o.useEffect(() => () => window.clearTimeout(s.current), []), [e, c, u];
}
function lt(t, n, e) {
  const c = n.length > 1 && Array.from(n).every((f) => f === n[0]) ? n[0] : n, u = e ? t.indexOf(e) : -1;
  let a = no(t, Math.max(u, 0));
  c.length === 1 && (a = a.filter((f) => f !== e));
  const r = a.find(
    (f) => f.textValue.toLowerCase().startsWith(c.toLowerCase())
  );
  return r !== e ? r : void 0;
}
function no(t, n) {
  return t.map((e, s) => t[(n + s) % t.length]);
}
var ro = Oe, ct = Le, so = Be, ao = Ve, lo = He, it = Ue, co = ze, io = Ge, dt = Ye, pt = Xe, po = Ze, uo = Qe, ut = et, ft = tt, mt = nt;
const Ho = ro, Uo = io, Fo = so, fo = o.forwardRef(({ className: t, children: n, ...e }, s) => /* @__PURE__ */ Q(
  ct,
  {
    ref: s,
    className: j(
      "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background data-[placeholder]:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      t
    ),
    ...e,
    children: [
      n,
      /* @__PURE__ */ i(ao, { asChild: !0, children: /* @__PURE__ */ i(Ae, { className: "size-4 opacity-50" }) })
    ]
  }
));
fo.displayName = ct.displayName;
const ht = o.forwardRef(({ className: t, ...n }, e) => /* @__PURE__ */ i(
  ut,
  {
    ref: e,
    className: j("flex cursor-default items-center justify-center py-1", t),
    ...n,
    children: /* @__PURE__ */ i(Bt, { className: "size-4" })
  }
));
ht.displayName = ut.displayName;
const vt = o.forwardRef(({ className: t, ...n }, e) => /* @__PURE__ */ i(
  ft,
  {
    ref: e,
    className: j("flex cursor-default items-center justify-center py-1", t),
    ...n,
    children: /* @__PURE__ */ i(Ae, { className: "size-4" })
  }
));
vt.displayName = ft.displayName;
const mo = o.forwardRef(({ className: t, children: n, position: e = "popper", ...s }, c) => /* @__PURE__ */ i(lo, { children: /* @__PURE__ */ Q(
  it,
  {
    ref: c,
    className: j(
      "relative z-50 max-h-[--radix-select-content-available-height] min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-select-content-transform-origin]",
      e === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      t
    ),
    position: e,
    ...s,
    children: [
      /* @__PURE__ */ i(ht, {}),
      /* @__PURE__ */ i(
        co,
        {
          className: j(
            "p-1",
            e === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: n
        }
      ),
      /* @__PURE__ */ i(vt, {})
    ]
  }
) }));
mo.displayName = it.displayName;
const ho = o.forwardRef(({ className: t, ...n }, e) => /* @__PURE__ */ i(
  dt,
  {
    ref: e,
    className: j("px-2 py-1.5 text-sm font-semibold", t),
    ...n
  }
));
ho.displayName = dt.displayName;
const vo = o.forwardRef(({ className: t, children: n, ...e }, s) => /* @__PURE__ */ Q(
  pt,
  {
    ref: s,
    className: j(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    ...e,
    children: [
      /* @__PURE__ */ i("span", { className: "absolute right-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ i(uo, { children: /* @__PURE__ */ i(Dt, { className: "size-4" }) }) }),
      /* @__PURE__ */ i(po, { children: n })
    ]
  }
));
vo.displayName = pt.displayName;
const go = o.forwardRef(({ className: t, ...n }, e) => /* @__PURE__ */ i(mt, { ref: e, className: j("-mx-1 my-1 h-px bg-muted", t), ...n }));
go.displayName = mt.displayName;
export {
  Ho as Select,
  mo as SelectContent,
  Uo as SelectGroup,
  vo as SelectItem,
  ho as SelectLabel,
  vt as SelectScrollDownButton,
  ht as SelectScrollUpButton,
  go as SelectSeparator,
  fo as SelectTrigger,
  Fo as SelectValue
};
//# sourceMappingURL=select.js.map
